import React, { useState } from "react";
import { Card, Typography } from "antd";
import { AuditOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import ListFournis from "./ListFournis";
import DemandeAgr from "./DemandeAgr";
import TableauOrdre from "./TableauOrdre";
import CreaFournDiv from "./CreaFournDiv";

const { Title } = Typography;

const tabListNoTitle = [
  {
    key: "1",
    label: "Listes des Fournisseurs",
  },
  {
    key: "2",
    label: "Demandes d'agrément",
  },
  {
    key: "3",
    label: "Tableau d'ordre",
  },
  {
    key: "4",
    label: "Création Fournisseurs Divers",
  },
];

const FournisseursSoins = () => {
  const [activeTabKey2, setActiveTabKey2] = useState("1");
  const [showCreaFournDiv, setShowCreaFournDiv] = useState(false);

  const userProfil = localStorage.getItem("profil");

  const onTab2Change = (key) => {
    setActiveTabKey2(key);
    setShowCreaFournDiv(false);
  };

  const handleShowCreaFournDiv = () => {
    setActiveTabKey2("4");
    setShowCreaFournDiv(true);
  };

  // Filtrer les onglets selon le profil
  const filteredTabList = tabListNoTitle.filter((tab) => {
    // role_5 n'a accès qu'à l'onglet 1 (Listes des Fournisseurs)
    if (userProfil === "role_5" && tab.key !== "1") {
      return false;
    }
    return true;
  });

  const updatedTabList = showCreaFournDiv
    ? filteredTabList
    : filteredTabList.filter((tab) => tab.key !== "4");

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <AuditOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
          }}
        >
          Fournisseurs de Soins
        </span>
      </div>
      <Card
        style={{
          width: "100%",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid #f0f0f0",
          overflow: "hidden",
        }}
        tabList={updatedTabList.map((tab) => ({
          ...tab,
          label: (
            <span style={{
              fontSize: 14,
              fontWeight: activeTabKey2 === tab.key ? 600 : 500,
              color: activeTabKey2 === tab.key ? "#1890ff" : "#595959",
              transition: "all 0.3s",
            }}>
              {tab.label}
            </span>
          ),
        }))}
        activeTabKey={activeTabKey2}
        onTabChange={onTab2Change}
        tabProps={{
          size: "large",
          tabBarStyle: {
            marginBottom: 0,
            paddingLeft: 16,
            paddingRight: 16,
            background: "#fafafa",
            borderBottom: "2px solid #f0f0f0",
          },
        }}
        bodyStyle={{
          padding: "20px",
          minHeight: 500,
          background: "#fff",
        }}
      >
        {activeTabKey2 === "1" && <ListFournis onShowCreaFournDiv={handleShowCreaFournDiv} />}
        {userProfil !== "role_5" && (
          <>
            {activeTabKey2 === "2" && <DemandeAgr />}
            {activeTabKey2 === "3" && <TableauOrdre />}
            {activeTabKey2 === "4" && showCreaFournDiv && <CreaFournDiv />}
          </>
        )}
      </Card>
    </div>
  );
};

export default FournisseursSoins;
